<div class="drp-pill" (click)="toggle()">
    <span>{{label}}</span>
    <svg viewBox="0 0 24 24" width="16" height="16" fill="none" [class.drp-chevron--open]="open"><path d="M6 9l6 6 6-6" stroke="#0a0a0a" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>
</div>
<div class="drp-panel" *ngIf="open" (click)="$event.stopPropagation()">
    <div class="drp-cal-header">
        <button type="button" class="drp-nav" (click)="prevMonth()">
            <svg viewBox="0 0 24 24" width="16" height="16" fill="none"><path d="M15 6l-6 6 6 6" stroke="#344054" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>
        </button>
        <span class="drp-month-label">{{monthLabel}}</span>
        <button type="button" class="drp-nav" (click)="nextMonth()">
            <svg viewBox="0 0 24 24" width="16" height="16" fill="none"><path d="M9 6l6 6-6 6" stroke="#344054" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>
        </button>
    </div>
    <div class="drp-weekdays">
        <span *ngFor="let w of weekdayLabels">{{w}}</span>
    </div>
    <div class="drp-days">
        <button type="button" *ngFor="let d of calendarDays; trackBy: trackByIso"
            class="drp-day"
            [class.drp-day--muted]="!d.inMonth"
            [class.drp-day--today]="d.isToday"
            [ngClass]="'drp-day--' + dayState(d.iso)"
            (click)="selectDay(d.iso)">
            {{d.day}}
        </button>
    </div>
    <button type="button" class="drp-apply" [disabled]="!draftFrom" (click)="apply()">Aplicar</button>
</div>
